import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../../store/modalSlice";
import { refundTableColumnsConfig } from "./refundTableColumnsConfig";

import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
const statusMap = {
  Approve: 15,
  Reject: 21,
};

export const RefundTablePage = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (refundId) => {
      navigate(`/refunds/${refundId}`);
    },
    [navigate]
  );
  const columnDefs = useMemo(
    () => refundTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail]
  );

  return <Table data={data} columns={columnDefs} />;
};
